import { useContext } from 'react';
import { FiltersContext } from '../contexts/FiltersContext';

const useFilters = () => useContext(FiltersContext);

export default useFilters;
